import React from 'react';
import './Textarea.css';

/**
 * Textarea Component
 * Standardized multi-line text input field
 * 
 * @param {string} label - Textarea label
 * @param {string} placeholder - Placeholder text
 * @param {string} value - Textarea value
 * @param {function} onChange - Change handler: (value: string) => void
 * @param {number} rows - Number of rows (default: 4)
 * @param {string} error - Error message
 * @param {boolean} disabled - Disabled state
 * @param {boolean} required - Required field indicator
 * @param {number} maxLength - Maximum character length
 * @param {string} helperText - Helper text below input
 * @param {string} className - Additional CSS classes
 */
const Textarea = ({
  label,
  placeholder,
  value,
  onChange,
  rows = 4,
  error,
  disabled = false,
  required = false,
  maxLength,
  helperText,
  className = ''
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const characterCount = value ? value.length : 0;
  const showCharacterCount = maxLength !== undefined;

  return (
    <div className={`textarea-container ${error ? 'error' : ''} ${className}`.trim()}>
      {label && (
        <label className="textarea-label">
          {label}
          {required && <span className="textarea-required">*</span>}
        </label>
      )}
      <textarea
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        className={`textarea ${error ? 'error' : ''}`.trim()}
        aria-required={required}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${label}-error` : helperText ? `${label}-helper` : undefined}
      />
      {(error || helperText || showCharacterCount) && (
        <div className="textarea-footer">
          {error && (
            <span id={`${label}-error`} className="textarea-error" role="alert">
              {error}
            </span>
          )}
          {!error && helperText && (
            <span id={`${label}-helper`} className="textarea-helper">
              {helperText}
            </span>
          )}
          {showCharacterCount && (
            <span className={`textarea-count ${characterCount >= maxLength ? 'max' : ''}`}>
              {characterCount} / {maxLength}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default Textarea;










